export type LocalCatalogCounts = {
  itemsEntrega: number;
  productosReposicion: number;
  mediosReporte: number;
  motivosReposicion: number;
};

export const EMPTY_LOCAL_CATALOG_COUNTS: LocalCatalogCounts = {
  itemsEntrega: 0,
  productosReposicion: 0,
  mediosReporte: 0,
  motivosReposicion: 0,
};
